import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faChevronRight } from '@fortawesome/free-solid-svg-icons';

// P5 (hub-and-spoke): droga POWROTNA z produktu do Bazy wiedzy. Artykuły linkowały
// do listingów, ale ze strony modelu nic nie prowadziło do treści.
//
// Listę dobiera BACKEND wg kategorii produktu (backend_api/seo.py: RELATED_ARTICLES)
// i oddaje w polu `related_articles`. Front tylko wyświetla — ta sama lista trafia
// do wersji dla bota, więc treść widoczna zgadza się z tą, którą czyta Google.
const RelatedArticles = ({ articles }) => {
  const { t } = useTranslation('model');
  if (!articles || articles.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 mt-6 mb-10">
      <section className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5 md:p-7">
        <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2 mb-4">
          <FontAwesomeIcon icon={faBookOpen} className="w-4 h-4 text-blue-500" />
          {t('warto_przeczytac')}
        </h2>
        <ul className="grid gap-2 sm:grid-cols-2">
          {articles.map((a) => (
            <li key={a.path}>
              <Link
                to={a.path}
                className="group flex items-start gap-2 rounded-lg border border-gray-200 p-3 hover:border-blue-200 hover:shadow-sm transition"
              >
                <span className="text-sm text-gray-700 group-hover:text-blue-700 leading-snug">
                  {a.title}
                </span>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="w-3 h-3 text-blue-400 shrink-0 mt-1"
                />
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default RelatedArticles;
